import {
  LOAD_LIMIT_FAILED,
  LOAD_LIMIT_INVALID_REQUEST,
  LOAD_LIMIT_LOADING,
  LOAD_LIMIT_SUCCESS,
  RESET_LOAD_LIMIT
} from "../types";

const initialState = {
  data: {},
  isLoading: false,
  failed: false,
  invalidRequest: false,
  success: false,
  networkError: ""
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOAD_LIMIT_LOADING:
      return {
        ...state,
        isLoading: true,
        failed: false,
        invalidRequest: false,
        success: false,
        networkError: "",
        data: {}
      };
    case LOAD_LIMIT_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: false,
        failed: true,
        networkError: "",
        data: action.payload
      };
    case LOAD_LIMIT_INVALID_REQUEST:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: true,
        failed: false,
        networkError: "",
        data: action.payload
      };
    case LOAD_LIMIT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: true,
        invalidRequest: false,
        networkError: "",
        data: action.payload
      };

    // case NETWORK_ERROR_UPGRADE_WALLET:
    //   return {
    //     ...state,
    //     isLoading: false,
    //     failed: false,
    //     success: false,
    //     invalidRequest: false,
    //     networkError: "Something went wrong.."
    //   };

    case RESET_LOAD_LIMIT:
      return (state = initialState);

    default:
      return state;
  }
};
